export const joinChartsData = (titleData, chartsData) => {
  const newData = [];

  titleData.forEach((value) => {
    const chart = chartsData.filter(
      (item) =>
        item.type === 'resp' ||
        (item.securityType === value.securityType &&
          item.symbol === value.symbol &&
          item.exchange === value.exchange),
    );

    newData.push({ chartData: chart, ...value });
  });

  return newData;
};
